import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-Home'
          }
        }
      ]
    },
    {
      path: '/legal',
      name: 'Legal',
      component: resolve => require(['@/view/Legal'], resolve),
      meta: {
        title: title + '-Legal'
      },
      children: [
        {
          path: '/legal/termService',
          name: 'Term of Service',
          component: resolve => require(['@/view/TermService'], resolve),
          meta: {
            title: title + '-Term of Service'
          }
        },
        {
          path: '/legal/privacyPolicy',
          name: 'Privacy Policy',
          component: resolve => require(['@/view/PrivacyPolicy'], resolve),
          meta: {
            title: title + '-Privacy Policy'
          }
        },
        {
          path: '/legal/cookiePolicy',
          name: 'Cookie Policy',
          component: resolve => require(['@/view/CookiePolicy'], resolve),
          meta: {
            title: title + '-Cookie Policy'
          }
        },
        {
          path: '/legal/refundPolicy',
          name: 'Refund Policy',
          component: resolve => require(['@/view/RefundPolicy'], resolve),
          meta: {
            title: title + '-Refund Policy'
          }
        }
      ]
    },
    {
      path: '/contactUs',
      name: 'Contact Us',
      component: resolve => require(['@/view/ContactUs'], resolve),
      meta: {
        title: title + '-Contact Us'
      },
      children: []
    },
    {
      path: '/GooglePlay',
      name: 'GooglePlay',
      component: resolve => require(['@/view/GooglePlay'], resolve),
      meta: {
        title: title + '-Google Play',
        showPublic:true
      },
      children: []
    },
    {
      path: '/TongitsPinoy',
      name: 'TongitsPinoy',
      component: resolve => require(['@/view/TongitsPinoy'], resolve),
      meta: {
        title: title + '-Tongits Pinoy',
        showPublic:true
      },
      children: [],

}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js